//Ground ball
export const GB = "GB";
//CAUSED_TURNOVER
export const CTO = "CTO";
//UNFORCED_ERR
export const UE = "UE";
//TAKEAWAY
export const TA = "TA";

// INTERCEPTION
export const INT = "INT";
//TURNOVER
export const TO = "TO";

export const CLEARS = "CLEARS";

export const C_SUCCESS = "C_SUCCESS";

export const SHOT_ATTEMPTS = "SHOT_ATTEMPTS";

export const SHOTS_OG = "SHOTS_OG";

export const SAVES = "SAVES";

export const TOT_GOALS = "TOT_GOALS";

export const ASSISTS = "ASSISTS";

// GOAL_AGAINST
export const GA = "GA";

// lostPossessions
export const TOT_LP = "TOT_LP";

export const TOT_RP = "TOT_RP";

export const PENALTY = "PENALTY";

export const ACTIVE_PENALTIES = "ACTIVE_PENALTIES";

export const FO_ATTEMPTS = "FO_ATTEMPTS";

export const FO_VIOLATIONS = "FO_VIOLATIONS";

export const FO_WONS = "FO_WONS";

export const POSSESSION_TIME = "POSSESSION_TIME";
export const PLAYED_IN_GAME = "PLAYED_IN_GAME";

export const PERIOD_STATS = "PERIOD_STATS";

export const CLEAR_ACTIVITY_LOG = "CLEAR_ACTIVITY_LOG";

export const GENERAL_DETAILS = "GENERAL_DETAILS";
export const GAME_RULES = "GAME_RULES";
export const CLOCK_SETTINGS = "CLOCK_SETTINGS";

export const TEAM_DETAILS = "TEAM_DETAILS";

export const REPLACE_ACTIVITY_LOG = "REPLACE_ACTIVITY_LOG"

export const GAME_LOG = "GAME_LOG";
export const LOGOUT = "LOGOUT";

export const ClockStatsOnly_actionType_prefix = `CLOCK_STATS_ONLY_`;
export const PREFIX = ClockStatsOnly_actionType_prefix;

const INITIAL_STATE = {
  teamA: {
    penalties: [],
    periodStats: [],
    possessionTime: [],
    playerStats: [],
    playedInGame: [],
  },
  teamB: {
    penalties: [],
    periodStats: [],
    possessionTime: [],
    playerStats: [],
    playedInGame: [],
  },
  general: {},
  activityLog: [],
  rules: {},
  clockSetting: {},
};

const clockStatsOnlyReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case `${PREFIX}${TEAM_DETAILS}`:
      return {
        ...state,
        [`${action.team}`]: {
          goals: 0,
          goalsAgainst: 0,
          ...action.payload,
          penalties: [],
          playerStats: [],
          possessionTime: [],
          playedInGame: [],
        },
      };

    case `${PREFIX}${GENERAL_DETAILS}`:
      return { ...state, general: action.payload };
    case `${PREFIX}${GAME_RULES}`:
      return { ...state, rules: action.payload };
    case `${PREFIX}${CLOCK_SETTINGS}`:
      return { ...state, clockSetting: action.payload };

    case `${PREFIX}${POSSESSION_TIME}`:
      return {
        ...state,
        [`${action.team}`]: {
          ...state[`${action.team}`],
          possessionTime: [...(state[`${action.team}`]?.possessionTime || []), action.payload],
        },
      };

    case `${PREFIX}${PLAYED_IN_GAME}`:
      return {
        ...state,
        [`${action.team}`]: {
          ...state[`${action.team}`],
          playedInGame: [...(state[`${action.team}`]?.playedInGame || []), ...action.payload],
        },
      };

    case `${PREFIX}${PERIOD_STATS}`:
      return {
        ...state,
        [`${action.team}`]: {
          ...state[`${action.team}`],
          periodStats: {
            ...state[`${action.team}`].periodStats,
            [`period${action.period}`]: {
              ...state[`${action.team}`].periodStats?.[`period${action.period}`],
              ...action.payload,
            },
          },
        },
      };

    case `${PREFIX}${SAVES}`:
      return { ...state, [`${action.team}`]: { ...state[`${action.team}`], saves: action.payload } };
    
      case `${PREFIX}${TOT_GOALS}`:
      return { ...state, [`${action.team}`]: { ...state[`${action.team}`], goals: action.payload } };

      case `${PREFIX}${ASSISTS}`:
      return { ...state, [`${action.team}`]: { ...state[`${action.team}`], assists: action.payload } };

    case `${PREFIX}${GA}`:
      return {
        ...state,
        [`${action.team}`]: { ...state[`${action.team}`], goalsAgainst: action.payload },
      };

    case `${PREFIX}${SHOT_ATTEMPTS}`:
      return {
        ...state,
        [`${action.team}`]: { ...state[`${action.team}`], shotAttempts: action.payload },
      };

    case `${PREFIX}${SHOTS_OG}`:
      return {
        ...state,
        [`${action.team}`]: { ...state[`${action.team}`], shotOG: action.payload },
      };

    case `${PREFIX}${TOT_LP}`:
      return {
        ...state,
        [`${action.team}`]: { ...state[`${action.team}`], lostPossessions: action.payload },
      };

    case `${PREFIX}${TOT_RP}`:
      return {
        ...state,
        [`${action.team}`]: { ...state[`${action.team}`], retainedPoss: action.payload },
      };

    case `${PREFIX}${GB}`:
      return {
        ...state,
        [`${action.team}`]: { ...state[`${action.team}`], groundBall: action.payload },
      };

    case `${PREFIX}${CTO}`:
      return {
        ...state,
        [`${action.team}`]: { ...state[`${action.team}`], causedTurnover: action.payload },
      };

    case `${PREFIX}${UE}`:
      return {
        ...state,
        [`${action.team}`]: { ...state[`${action.team}`], unforcedError: action.payload },
      };

    case `${PREFIX}${TA}`:
      return { ...state, [`${action.team}`]: { ...state[`${action.team}`], takeAway: action.payload } };

    case `${PREFIX}${INT}`:
      return { ...state, [`${action.team}`]: { ...state[`${action.team}`], interception: action.payload } };

    case `${PREFIX}${TO}`:
      return { ...state, [`${action.team}`]: { ...state[`${action.team}`], turnOver: action.payload } };

    case `${PREFIX}${CLEARS}`:
      return { ...state, [`${action.team}`]: { ...state[`${action.team}`], clears: action.payload } };

    case `${PREFIX}${C_SUCCESS}`:
      return {
        ...state,
        [`${action.team}`]: { ...state[`${action.team}`], clearsSuccessfull: action.payload },
      };

    case `${PREFIX}${PENALTY}`:
      return {
        ...state,
        [`${action.team}`]: { ...state[`${action.team}`], penaltyNum: action.payload },
      };  

    case `${PREFIX}${ACTIVE_PENALTIES}`:
      return {
        ...state,
        [`${action.team}`]: { ...state[`${action.team}`], releasableActivePenlaties: action.payload },
      };

    case `${PREFIX}${FO_ATTEMPTS}`:
      return {
        ...state,
        [`${action.team}`]: { ...state[`${action.team}`], foffsAttempts: action.payload },
      };

    case `${PREFIX}${FO_VIOLATIONS}`:
      return {
        ...state,
        [`${action.team}`]: { ...state[`${action.team}`], faceoffViolations: action.payload },
      };

    case `${PREFIX}${FO_WONS}`:
      return {
        ...state,
        [`${action.team}`]: { ...state[`${action.team}`], faceoffsWon: action.payload },
      };

    case `${PREFIX}${GAME_LOG}`: // GAME_LOG
      return { ...state, activityLog: [...state.activityLog, action.payload] };
    case `${PREFIX}${CLEAR_ACTIVITY_LOG}`:
      return { ...state, activityLog: [] };

    case `${PREFIX}${REPLACE_ACTIVITY_LOG}`:
      return { ...state, activityLog: action.payload };
    case `${PREFIX}${LOGOUT}`:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default clockStatsOnlyReducer;
